<template>
    <v-dialog v-model="showModal" max-width="500px" persistent>    
        <v-card flat>
            <v-toolbar dark class="primary">
            <v-btn icon @click.native="showModal = false" dark>
                <v-icon>fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>{{title}}</v-toolbar-title>                    
            </v-toolbar>                 
            <v-card-text>
                <v-container  grid-list-xl>
                    <v-layout row wrap>   
                        <v-flex xs6>
                            <TimePicker v-model="breakData.timeStart" text="Początek"></TimePicker>
                        </v-flex>                            
                        <v-flex xs6>
                            <TimePicker v-model="breakData.timeEnd" text="Koniec"></TimePicker>
                        </v-flex> 
                        <v-flex xs12 v-if="breakData.id == 0">
                            <v-list subheader>
                            <v-subheader>Dni:</v-subheader>
                            <v-list-item v-for="day in days" :key="day.id">
                                <v-list-item-action>
                                    <v-checkbox v-model="day.checked" :label="day.name" :id="day.name" :name="day.name" :checked="day.checked"></v-checkbox>
                                </v-list-item-action>
                            </v-list-item>
                            </v-list>                            
                        </v-flex>                          
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="closeForm" color="error">Zamknij</v-btn>
                <v-btn color="success" @click="handleSubmit">Zapisz</v-btn>
            </v-card-actions>            
        </v-card>
    </v-dialog>
</template>

<script>
import TimePicker from "@/components/shared/TimePicker"
import { therapistsService } from "@/services/";
import swal from "sweetalert";
export default {
    name: 'AddEditBreak',
    data () {
      return {
          days: [
              { id: 1, name: 'Poniedziałek', checked: false },
              { id: 2, name: 'Wtorek', checked: false },
              { id: 3, name: 'Środa', checked: false },
              { id: 4, name: 'Czwartek', checked: false },
              { id: 5, name: 'Piątek', checked: false },
              { id: 6, name: 'Sobota', checked: false },
              { id: 0, name: 'Niedziela', checked: false },
          ],
          title: 'Dodawanie nowej przerwy'
      }
    },
    props: {
        visible: Boolean,
        breakData: Object,
        therapistID: Number
    },    
    computed: {
        showModal: {
            get: function() {
                if(!this.visible)
                {
                    this.clearFormData()
                    this.errors.clear();
                }
                return this.visible
            },
            set: function(value) {                
                if(!value){
                this.$emit('close')
                }

            }
        }
    },

    watch: {
        visible: function(newv)
        {
            if(newv)
            {                                
                if(this.breakData.id == 0)
                {
                    this.clearFormData()
                    this.title = 'Dodawanie nowej przerwy'
                }
                else
                {
                    this.title = 'Edycja przerwy w '+this.getDayName(this.breakData.day)
                }
            }            
        }
    },
    methods: {
        showError(close, text) {
            swal({
                title: "Błąd",
                text: text,
                icon: "warning",
                button: "OK"
            }).then(() => {
                this.loading = false;
                if (close) {
                this.$emit("close");
                }
            });
        },        
        updateFormData() {
            
        },
        clearFormData() {
            this.days.forEach(f=> {
                f.checked = false
            })            
        },
        getDayName(id)
        {
            switch(id)
            {
                case 1:
                    return 'Poniedziałek'            
                case 2:
                    return 'Wtorek';                
                case 3:
                    return 'Środe';                
                case 4:
                    return 'Czwartek';                
                case 5:
                    return 'Piątek';                
                case 6:
                    return 'Sobote';                
                case 0:
                    return 'Niedziele';                
            }
        },        
        closeForm() {            
            this.$emit("close");
            this.clearFormData()
        },   
        saveNewBreak() {
            if(!this.breakData.timeStart)
            {
                this.showError(false,'Proszę podać godzinę początkową.')
                return;
            }
            if(!this.breakData.timeEnd)
            {
                this.showError(false,'Proszę podać godzinę końcową.')
                return;
            }
            if(!this.days.some(f=>f.checked == true))
            {
                this.showError(false,'Proszę wybrać co najmniej jeden dzień.')
                return;                
            }
            var listOfDays = []
            this.days.forEach(f=> {
                if(f.checked)
                    listOfDays.push(f.id)
            })
            
            therapistsService.addTherapistBreaks({
                days: listOfDays,
                startTime: this.breakData.timeStart,
                endTime: this.breakData.timeEnd,
                therapistID: this.therapistID
            }).then(success=> {                
                this.$emit('close')
                this.$emit('breaksSaved',success.data.result.items)
            }).catch(e=> {
                console.log(e)
                this.showError(false, 'Błąd zapisu przerwy.')
            })            

        },
        updateBreak() {            
            therapistsService.UpdateTherapistBreak({
                id: this.breakData.id,
                startTime: this.breakData.timeStart,
                endTime: this.breakData.timeEnd,                
            }).then(()=> {                
                    this.$emit('breakUpdated',this.breakData)
                    this.$emit('close')                    
            }).catch(()=> {                
                this.showError(false, 'Błąd zapisu przerwy.')
            })            

            
        },
        handleSubmit() {
            if(this.breakData.id == 0)
            {
                this.saveNewBreak()
            }            
            else
            {
                this.updateBreak()
            }
        }     
    },
    components: {
        TimePicker
    }
}
</script>

<style>

</style>
